import Footer from './Footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/common/components/Footer/index.tsx